import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1045e28c&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=less&"
import style1 from "./App.vue?vue&type=style&index=1&id=1045e28c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045e28c",
  null
  
)

export default component.exports